import React from "react";
import { styled } from "@mui/material/styles";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { Box } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PreviewIcon from "@mui/icons-material/Preview";
import CheckIcon from "@mui/icons-material/Check";

export const AnimatedConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 21,
  },
  [`& .${stepConnectorClasses.line}`]: {
    position: "relative",
    height: 3,
    border: "none",
    backgroundColor: "#e0e0e0",
    borderRadius: 1,
    overflow: "hidden",
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}::after`]: {
    content: '""',
    position: "absolute",
    left: 0,
    top: 0,
    height: "100%",
    width: "100%",
    backgroundColor: "#00D4AA",
    transformOrigin: "left",
    animation: "growLine 1s ease forwards",
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: "#00D4AA",
  },
  "@keyframes growLine": {
    "0%": { transform: "scaleX(0)" },
    "100%": { transform: "scaleX(1)" },
  },
}));

export function CustomStepIcon(props) {
  const { active, completed, icon } = props;

  const icons = {
    1: <SettingsIcon />,
    2: <ScheduleIcon />,
    3: <PreviewIcon />,
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 40,
        height: 40,
        borderRadius: "50%",
        bgcolor: completed ? "#00D4AA" : active ? "#00D4AA" : "rgba(0,0,0,0.1)",
        color: "white",
      }}
    >
      {completed ? <CheckIcon /> : icons[String(icon)]}
    </Box>
  );
}
